//const BASE_URL = "http://localhost:3000/api/v1";
const BASE_URL = "https://status-be.onrender.com/api/v1";

export default BASE_URL;
